// extracted by mini-css-extract-plugin
export default {"videosection":"VideoSection_videosection__5c-FF","videoContainer":"VideoSection_videoContainer__wgzdu","video":"VideoSection_video__WPmTF"};